/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const PERMISSION_FETCH_REQUEST = 'PERMISSION_FETCH_REQUEST';
export const PERMISSION_FETCH_REQUEST_SUCCESS = 'PERMISSION_FETCH_REQUEST_SUCCESS';
export const PERMISSION_FETCH_REQUEST_FAILURE = 'PERMISSION_FETCH_REQUEST_FAILURE';

export const SINGLE_PERMISSION_FETCH_REQUEST = 'SINGLE_PERMISSION_FETCH_REQUEST';
export const SINGLE_PERMISSION_FETCH_REQUEST_FAILURE = 'SINGLE_PERMISSION_FETCH_REQUEST_FAILURE';
export const SINGLE_PERMISSION_FETCH_REQUEST_SUCCESS = 'SINGLE_PERMISSION_FETCH_REQUEST_SUCCESS';

export const CLEAN_PERMISSION_REQUEST = 'CLEAN_PERMISSION_REQUEST';
